module.exports = __webpack_public_path__ + "static/img/ninja-can-30.175df1c8.png";